




























































import { defineComponent } from '@vue/composition-api'

import { navLinks } from '@/router'

type Props = {
  title: string
  isValidationNg: boolean
}

export default defineComponent({
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      default: null,
    },
    isValidationNg: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, ctx) {
    const isOcrPage = ctx.root.$router.currentRoute.path === '/ocr'
    const isQAPage =
      ctx.root.$router.currentRoute.path === '/questionnaire-answer'
    const isLoginPage =
      ctx.root.$router.currentRoute.path === '/login' ||
      ctx.root.$router.currentRoute.path === '/password-setting'
    const isInputEmailPage =
      ctx.root.$router.currentRoute.path === '/input-email'
    const pageTitle = props.title
      ? props.title
      : navLinks
          .flatMap(nav => nav.links)
          .find(link => link.to === ctx.root.$router.currentRoute.path)
          ?.title || ''

    const logout = () => {
      ctx.root.$store.dispatch('user/logout')
    }

    return {
      isOcrPage,
      isQAPage,
      isLoginPage,
      isInputEmailPage,
      pageTitle,
      logout,
    }
  },
})
